import { HeraldApplicationResponse } from '@common/types/herald/herald-types';
import { getHeraldApiActiveProducts } from '@common/utils';
import { ButtonProps } from '@common-components';
import { messages } from 'i18n';
import { MinimalFormProceedDialogMode } from './types';

interface MinimalFormProceedDialogModeProps {
  header: string;
  content: string;
  proceedButton: ButtonProps;
  cancelButton?: ButtonProps;
}

interface Props {
  mode: MinimalFormProceedDialogMode;
  onClose: () => void;
  onProceed: () => void;
  heraldApplicationResponse?: HeraldApplicationResponse;
}

export function useGetModeProps({
  mode,
  onClose,
  onProceed,
  heraldApplicationResponse,
}: Props): MinimalFormProceedDialogModeProps {
  const minimalFormProceedDialogMessages = messages.submissionModal.minimalFormProceedDialog;
  switch (mode) {
    case MinimalFormProceedDialogMode.IncompleteInformation:
      return {
        header: minimalFormProceedDialogMessages.incompleteInformation.header,
        content: minimalFormProceedDialogMessages.incompleteInformation.content,
        proceedButton: {
          children: minimalFormProceedDialogMessages.incompleteInformation.proceedButton,
          onClick: onProceed,
        },
        cancelButton: {
          children: minimalFormProceedDialogMessages.incompleteInformation.cancelButton,
          onClick: onClose,
        },
      };
    case MinimalFormProceedDialogMode.NoAvailableApiProducts:
      return {
        header: minimalFormProceedDialogMessages.noAvailableApiProducts.header,
        content: minimalFormProceedDialogMessages.noAvailableApiProducts.content,
        proceedButton: {
          children: minimalFormProceedDialogMessages.noAvailableApiProducts.proceedButton,
          onClick: onProceed,
        },
      };
    default:
      return {
        header: minimalFormProceedDialogMessages.apiProductsAvailable.header,
        content: minimalFormProceedDialogMessages.apiProductsAvailable.content(
          heraldApplicationResponse
            ? getHeraldApiActiveProducts(
                heraldApplicationResponse.application,
                heraldApplicationResponse.quote_exits || [],
              ).length
            : undefined,
        ),
        proceedButton: {
          children: minimalFormProceedDialogMessages.apiProductsAvailable.proceedButton,
          onClick: onClose,
        },
      };
  }
}
